import { PalletLayer } from 'src/app/core/types';

export const PALLET_LAYER_NAME_KEY = 'pallet_layer_name';
export const DEFAULT_LAYER_TYPE_NAME_RE = /^layer(?:\s*type)?\s*(\d+)$/i;

export function parseDefaultLayerTypeNumber(name: string | undefined | null): number | null {
  const match = DEFAULT_LAYER_TYPE_NAME_RE.exec((name ?? '').trim());
  return match ? parseInt(match[1], 10) : null;
}

/**
 * Type index (1..n) from position in the group's layer-type catalog.
 * Backend layer names like "Layer type 11" use layer id, not type index — ignore that number.
 */
export function getPalletLayerTypeNumber(layer: PalletLayer, allLayerTypes: PalletLayer[]): number {
  const typeIndex = (allLayerTypes ?? []).findIndex((candidate) => candidate.id === layer.id);
  return typeIndex >= 0 ? typeIndex + 1 : 1;
}

export function formatDefaultPalletLayerTypeName(
  typeNumber: number,
  instant: (key: string, params?: Record<string, unknown>) => string,
): string {
  const translated = instant(PALLET_LAYER_NAME_KEY, { n: typeNumber });
  return translated === PALLET_LAYER_NAME_KEY ? `Warstwa typ ${typeNumber}` : translated;
}

export function resolvePalletLayerTypeDisplayName(
  layer: PalletLayer,
  allLayerTypes: PalletLayer[],
  instant: (key: string, params?: Record<string, unknown>) => string,
): string {
  const raw = layer.name?.trim();
  const typeNumber = getPalletLayerTypeNumber(layer, allLayerTypes);
  const isBackendLayerTypeLabel = raw ? DEFAULT_LAYER_TYPE_NAME_RE.test(raw) : true;
  if (isBackendLayerTypeLabel || !raw) {
    return formatDefaultPalletLayerTypeName(typeNumber, instant);
  }
  const looksLikeI18nKey = /^[a-z][a-z0-9_]*$/i.test(raw);
  if (!looksLikeI18nKey) {
    const translated = instant(raw);
    return translated !== raw ? translated : raw;
  }
  return formatDefaultPalletLayerTypeName(typeNumber, instant);
}
